<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{ (this.data.notificationDetails ? data.sysText.editActionItemNotifcationInfo_header : data.sysText.addActionItemNotifcationInfo_header) | titlecase }}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="cancel()" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>
<mat-dialog-content>
  <form [formGroup]="form" class="dialog-content-form">
    <app-text-area
      [control]="this.form.controls.notificationName"
      [icon]="'assignment'"
      [label]="data.sysText.notificationName"
      [rows]="1">
    </app-text-area>
    <app-text-area
      [control]="form.controls.description"
      [label]="data.sysText.notificationDescription"
      [icon]="'description'"
      [rows]="1">
    </app-text-area>
    <div class="section-container">
      <mat-expansion-panel class="info-panel remove-mat-expansion-panel-padding" (opened)="warningTriggersOpenState = true" (closed)="warningTriggersOpenState = false"
        [expanded]="warningTriggersOpenState">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="section-header-container">
              <p class="overline grey1 semibold section-title">{{ data.sysText.notificationWarningTriggers | uppercase }}</p>
              <mat-divider class="section-header-underline" aria-hidden="true"></mat-divider>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-action-notification-triggers-form
          [sysText]="data.sysText"
          [formGroup]="form"
          [triggerFormArray]="warningTriggers"
          [formArrayName]="actionNotificationTriggerForms.warningTriggers"
          [triggerOptions]="availableWarningOptions"
          [otherActionItemOptions]="data.options.otherActionItemOptions"
          (emitAddTriggerFormGroup)="addTriggerFormGroup($event)">
        </app-action-notification-triggers-form>
      </mat-expansion-panel>
    </div>
    <div class="section-container">
      <mat-expansion-panel class="info-panel remove-mat-expansion-panel-padding" (opened)="dueTriggersOpenState = true" (closed)="dueTriggersOpenState = false"
        [expanded]="dueTriggersOpenState">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="section-header-container">
              <p class="overline grey1 semibold section-title">{{data.sysText.notificationDueTriggers | uppercase}}
              </p>
              <mat-divider class="section-header-underline" aria-hidden="true"></mat-divider>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-action-notification-triggers-form
          [sysText]="data.sysText"
          [formGroup]="form"
          [triggerFormArray]="dueTriggers"
          [formArrayName]="actionNotificationTriggerForms.dueTriggers"
          [triggerOptions]="availableDueOptions"
          [otherActionItemOptions]="data.options.otherActionItemOptions"
          (emitAddTriggerFormGroup)="addTriggerFormGroup($event)">
        </app-action-notification-triggers-form>
      </mat-expansion-panel>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="cancel()">
      {{ data.sysText.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && save()">
    {{ data.sysText.save }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>

